import { render, staticRenderFns } from "./AccountSetTemplates.vue?vue&type=template&id=7f64795d"
import script from "./AccountSetTemplates.vue?vue&type=script&lang=js"
export * from "./AccountSetTemplates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports